<template>
  <div class="p-the-g01-content">
    <div class="p-the-g01-content__button_list">
      <G01ContentButtonList
        :categories="categories"
        :is-category="isCategory"
      />
      <slot />
    </div>
  </div>
</template>

<script lang="ts">
import G01ContentButtonList from "@/general/components/pages/parts/Ranking/G01ContentButtonList.vue";
import { Options, Vue } from 'vue-class-component';

@Options({
  props: {
	categories: { type: Array, required: true, default: () => ([]) },
	isCategory: { type: Boolean, required: true, default: true }
  },
  components: {
    G01ContentButtonList
  }
})
export default class TheG01Content extends Vue {
  categories!: any;
  isCategory!: boolean;
}
</script>

<style lang="scss" scoped>
.p-the-g01-content {
  &__button_list {
    max-width: rem(1200);
    margin: 0 auto;
  }
}
</style>
